import { useFullscreen, useWakeLock } from '@vueuse/core';
import { ref } from 'vue';

export function useKioskMode() {
  const root = ref(document.documentElement);
  const { isFullscreen, enter: enterFullscreen } = useFullscreen(root);
  const { isSupported: wakeLockSupported, request: requestWakeLock } = useWakeLock();

  async function enableKiosk(): Promise<void> {
    try {
      await enterFullscreen();
    } catch (err) {
      console.warn('[kiosk] Fullscreen request failed:', err);
    }

    if (wakeLockSupported.value) {
      try {
        await requestWakeLock('screen');
      } catch (err) {
        console.warn('[kiosk] Wake lock request failed:', err);
      }
    }
  }

  return { isFullscreen, wakeLockSupported, enableKiosk };
}
